import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formLabel',
})
export class FormLabelPipe implements PipeTransform {
    public transform(value: string | number, required: boolean = true, suffix?: 'date' | 'select' | string): string {
        if (required) {
            value += '*';
        }
        switch (suffix) {
            case 'date':
                return value + ' (tt.mm.jjjj)';
            case 'select':
                return value + ' - Bitte wählen';
            default:
                return value + (suffix ?? '');
        }
    }
}
